import type { ValueGetterParams } from 'ag-grid-community';

export const valueGetter = (params: ValueGetterParams<ResponseDataT>) => {
    if (!params) return '';
    const field = params.colDef.field ?? '';
    const data = params?.data && params.data[field];
    const aggregatedData =
        params?.node?.aggData && params?.node?.aggData[field];
    return data || aggregatedData || '';
};

export const percentageGetter = (
    params: ValueGetterParams<ResponseDataT>,
): number => 100 * valueGetter(params);
